import(/* webpackMode: "eager" */ "/fetest-martina/app/globals.css");
import(/* webpackMode: "eager" */ "/fetest-martina/components/sentry-provider.tsx");
import(/* webpackMode: "eager" */ "/fetest-martina/components/theme-provider.tsx");
import(/* webpackMode: "eager" */ "/fetest-martina/components/ui/toaster.tsx");
import(/* webpackMode: "eager" */ "/fetest-martina/components/ui/tooltip.tsx")